import { render, staticRenderFns } from "./FinalAgentSignBoard.vue?vue&type=template&id=45ef2292&scoped=true"
import script from "./FinalAgentSignBoard.vue?vue&type=script&lang=js"
export * from "./FinalAgentSignBoard.vue?vue&type=script&lang=js"
import style0 from "./FinalAgentSignBoard.vue?vue&type=style&index=0&id=45ef2292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef2292",
  null
  
)

/* custom blocks */
import block0 from "./FinalAgentSignBoard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports